import type { MerchCategory } from "./merchPricing";

export const BLANK_FOLDER = "truevined/merch/blanks";

export const MOCKUP_WIDTH = 1000;

export const MOCKUP_HEIGHT = 1250;

export const MOCKUP_ZOOM = 0.84;

export const GRID_MOCKUP_WIDTH = 900;

export const ITEM_MOCKUP_WIDTH = 1200;

export interface MockupPlacement {
  widthRatio: number;
  yRatio: number;
}

export const MERCH_MOCKUP_PLACEMENT: Record<MerchCategory, MockupPlacement> = {
  tee: { widthRatio: 0.3, yRatio: 0.3 },
  sweatshirt: { widthRatio: 0.28, yRatio: 0.325 },
  hoodie: { widthRatio: 0.28, yRatio: 0.42 },
  tank: { widthRatio: 0.26, yRatio: 0.325 },
};

export function layerReference(publicId: string): string {
  return publicId
    .replace(/^\/+/, "")
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/,/g, "%2C")
    .replace(/\//g, ":");
}

export interface MockupInput {
  cloudName: string;
  blankPublicId: string;
  designPublicId: string;
  category: MerchCategory;
  garmentIsDark: boolean;
  width?: number;
}

export function buildMockupUrl(input: MockupInput): string {
  const placement = MERCH_MOCKUP_PLACEMENT[input.category] ?? MERCH_MOCKUP_PLACEMENT.tee;
  const target = Math.max(200, Math.round(input.width ?? MOCKUP_WIDTH));
  const width = Math.round(target / MOCKUP_ZOOM);
  const height = Math.round((width * MOCKUP_HEIGHT) / MOCKUP_WIDTH);
  const layer = [`l_${layerReference(input.designPublicId)}`, `w_${placement.widthRatio}`, "fl_relative"].join(",");
  const apply = [
    "g_north",
    `y_${placement.yRatio}`,
    "fl_relative",
    input.garmentIsDark ? "o_94" : "e_multiply",
    "fl_layer_apply",
  ].join(",");

  return [
    `https://res.cloudinary.com/${input.cloudName}/image/upload`,
    `c_fill,g_center,w_${width},h_${height}`,
    layer,
    apply,
    `c_crop,w_${MOCKUP_ZOOM},h_${MOCKUP_ZOOM},g_center`,
    "f_auto,q_auto",
    input.blankPublicId.replace(/^\/+/, ""),
  ].join("/");
}

export function blankPublicIdFor(productSlug: string, colorName: string): string {
  const slug = (value: string) =>
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  return `${BLANK_FOLDER}/${slug(productSlug)}-${slug(colorName)}`;
}
